import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SmartModalService } from 'app/core/services/smart-modal.service';

@Component({
    selector: 'itpx-custom-topic-subtopic-add',
    templateUrl: './custom-topic-subtopic-add.component.html',
    styleUrls: ['./custom-topic-subtopic-add.component.css']
})
export class CustomTopicSubtopicAddComponent implements OnInit {
    readonly component: string = 'content-uploader';
    readonly allowedFormats = ['png', 'jpg', 'jpeg']
    form: FormGroup;
    @Input() data;

    constructor(
        private modalService: SmartModalService,
        private fb: FormBuilder) { }

    ngOnInit() {
        this.buildForm();
        if (this.data) this.patchForm(this.data);
    }

    onSubmit() {
        let result = this.form.value;
        this.modalService.sendResult(result);
    }
    onCancel() {
        this.modalService.close();
    }

    buildForm() {
        this.form = this.fb.group({
            title: [null, Validators.required],
            imageURL: [null],
            description: [''],
            nested: [[]],
            parent: [null]
        });
    }

    patchForm(details: any) {
        this.form = this.fb.group({
            title: [details.title, Validators.required],
            description: [details.description],
            nested: [details.nested],
            nesting: [details.nesting],
            code: [details.code],
            id: [details.id],
            parent: [details.parent]
        });
    }

    onUploadComplete(event: any) {
        this.form.get('imageURL').setValue(event.data.path);
    }
}



// WEBPACK FOOTER //
// ./src/app/agora/components/product-data/custom-topics/custom-topic-subtopic-add/custom-topic-subtopic-add.component.ts